import { CircularProgress } from '@civilgrid/ui/components';
import { useParams } from '@tanstack/react-router';
import { useAsyncRetry } from 'react-use';
import { getDataRequest as apiGetDataRequest } from '~/api/civilsearch';
import GeneralForm from './GeneralForm';
import RequestScopeBanner from './RequestScopeBanner';

export default function General() {
  const { requestId } = useParams({ strict: false }) as { requestId: string };

  const dataRequest = useAsyncRetry(async () => {
    return await apiGetDataRequest(requestId);
  }, [requestId]);

  if (dataRequest.loading) return <CircularProgress indeterminate />;
  if (dataRequest.error || !dataRequest.value) {
    return <div>An error occurred fetching the request</div>;
  }

  return (
    <>
      <RequestScopeBanner dataRequest={dataRequest.value} />
      <GeneralForm dataRequest={dataRequest.value} refetch={dataRequest.retry} />
    </>
  );
}
